import React, { useState } from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { connect, useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../_metronic";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
import { logout } from "../../crud/auth.crud";
import { actions } from "../../store/ducks/auth.duck";

function UserProfile({ me, showHi, showAvatar }) {
  const dispatch = useDispatch();
  const isImpersonating = me?.impersonation != null;
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      dispatch(actions.logout());
    }
  };

  if (!me?.identity?.usu_name) {
    handleLogout();
    return null;
  }

  return (
    <Dropdown
      className="kt-header__topbar-item kt-header__topbar-item--user"
      drop="down"
      alignRight
      onToggle={(nextShow) => setIsOpen(nextShow)}
    >
      <Dropdown.Toggle
        as={HeaderDropdownToggle}
        id="dropdown-toggle-user-profile"
      >
        <div className="kt-header__topbar-user">
          {showHi && (
            <span className="kt-header__topbar-username kt-hidden-mobile">
              {me.identity?.usu_name}
            </span>
          )}

          {showAvatar && (
            <div
              style={{
                width: "34px",
                height: "34px",
                marginLeft: "8px",
                backgroundImage: `url(${
                  me.identity?.foto?.url
                    ? me.identity.foto.url
                    : "/images/no-profile.png"
                })`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "50% 50%",
                borderRadius: "50%",
              }}
            />
          )}

          <i
            className="fas fa-chevron-down kt-hidden-mobile"
            style={{
              marginLeft: "8px",
              fontSize: "10px",
              transition: "transform 0.2s ease",
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
        <div
          className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
          style={{
            backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-5.jpg")})`,
          }}
        >
          {showAvatar && (
            <div className="kt-user-card__avatar">
              <span className="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success">
                <img
                  alt=""
                  src={
                    me.identity?.foto?.url
                      ? me.identity.foto.url
                      : "/images/no-profile.png"
                  }
                />
              </span>
            </div>
          )}

          <div className="kt-user-card__name">{me.identity?.usu_name}</div>
        </div>

        <div className="kt-notification">
          <Link
            to={"/usuario/edit/" + me.identity?.id}
            className="kt-notification__item"
          >
            <div className="kt-notification__item-icon">
              <i className="flaticon2-user" />
            </div>
            <div className="kt-notification__item-details">
              <div className="kt-notification__item-title kt-font-bold">
                Meu Perfil
              </div>
              <div className="kt-notification__item-time">
                Atualize suas informações.
              </div>
            </div>
          </Link>

          <div
            className="kt-notification__custom"
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            {!isImpersonating && (
              <Link
                to="/seguranca"
                className="btn btn-outline-primary btn-bold"
              >
                <i className="fas fa-shield-alt mr-1"></i> Segurança
              </Link>
            )}
            <button onClick={handleLogout} className="btn btn-primary btn-bold">
              Sair
            </button>
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}

const mapStateToProps = ({ auth: { me } }) => ({ me });

export default connect(mapStateToProps)(UserProfile);
